import { render, staticRenderFns } from "./LottieLoader.vue?vue&type=template&id=6c2f95e0&"
import script from "./LottieLoader.vue?vue&type=script&lang=js&"
export * from "./LottieLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports